import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../../aiPluginType';

import {
	getAreAiEntryPointsDisabled,
	useAreAiEntryPointsDisabled,
} from './use-are-ai-entry-points-disabled';
import { getIsOffline, useIsOffline } from './use-is-offline';

/**
 * Returns whether any AI entry point (toolbar buttons, quick insert, etc.) should be disabled.
 * Combines offline state and the `toggleAiEntryPoints` action state (gated behind
 * `platform_editor_ai_toggle_entry_points`).
 */
export const getIsAiEntryPointDisabled = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean => {
	return getIsOffline(api) || getAreAiEntryPointsDisabled(api);
};

export const useIsAiEntryPointDisabled = (api: ExtractInjectionAPI<AIPlugin> | undefined): boolean => {
	const isOffline = useIsOffline(api);
	const areAiEntryPointsDisabled = useAreAiEntryPointsDisabled(api);
	return isOffline || areAiEntryPointsDisabled;
};
